import React from 'react';
import {File as FWFile} from 'FW/Models/File';
import InlineEditableElement from 'Components/InlineEditableElement';
import _ from 'underscore';
import './tabs.scss';

function tabsHoc(Component) {
  return class TabsHOC extends React.Component {
    constructor() {
      super(...arguments);
      this.tabActionClicked = this.tabActionClicked.bind(this);
      this.tabClicked = this.tabClicked.bind(this);
      this.fontFamilyChanged = this.fontFamilyChanged.bind(this);
      this.filesFetched = [];
      this.selectedTab = 0;
    }

    tabActionClicked(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    fontFamilyChanged(fonts) {
      let extantFonts = this.props.section.prop('fonts') || [];
      extantFonts.forEach(font => {
        fonts.push(font);
      });
      let uniqueFamilies = [];
      $.each(fonts, function(i, el) {
        if ($.inArray(el, uniqueFamilies) === -1) uniqueFamilies.push(el);
      });
      uniqueFamilies.sort((a, b) => {
        return a > b;
      });
      if (uniqueFamilies.join(',') !== extantFonts.join(',')) {
        this.props.section.prop('fonts', uniqueFamilies);
        FW.store.get('page').getFonts();
      }
    }

    tabClicked(i, e) {
      //console.log(i,p,e);
      e.preventDefault();
      e.stopPropagation();
      this.selectedTab = i;
      this.forceUpdate();
    }

    componentDidMount() {
      this.props.section.on(
        'change',
        () => {
          this.forceUpdate();
        },
        this
      );
    }

    componentWillUnmount() {
      this.props.section.off(null, null, this);
    }

    tabChanged(tabIndex, value) {
      let tabs = _.clone(this.props.section.prop('tabs'));
      tabs[tabIndex].content = value;
      this.props.section.prop('tabs', tabs);
    }

    render() {
      let props = _.clone(this.props);
      props.tabChanged = this.tabChanged;
      props.tabActionClicked = this.tabActionClicked;
      props.filesFetched = this.filesFetched;
      props.tabClicked = this.tabClicked;
      props.selectedTab = this.selectedTab;
      props.fontFamilyChanged = this.fontFamilyChanged;

      return <Component {...props} />;
    }
  };
}

class Tabs extends React.Component {
  render() {
    let section = this.props.section;
    const tabHeight = section.prop('options').tab_height;
    const tabStyle = section.prop('options').tab_style || 'buttons';
    const showBorders = section.prop('options').showBorders;
    let tabButtons = section.prop('tabs').map((tab, i) => {
      let selectedClass =
        this.props.selectedTab === i ? '-selected' : '-unselected';
      let buttonStyle =
        tabStyle === 'tabs'
          ? {borderColor: section.prop('options').borderColor || '#aaa'}
          : {};
      return (
        <li
          onClick={this.props.tabClicked.bind(this, i)}
          key={`tabButton-${i}`}
          style={buttonStyle}
          className={
            'tab' +
            selectedClass +
            ' tabButton ' +
            (showBorders ? 'borders ' : 'noBorders')
          }
        >
          <div className={'tabContentContainer'}>
            <i
              className={
                'tabIcon ' + 'fa ' + tab.icon + ' icon' + selectedClass
              }
            />
            <h3 className={'tabTitle'}>{tab.title}</h3>
          </div>
        </li>
      );
    });

    let tabs = section.prop('tabs').map((tab, i) => {
      let backgroundUrl = null;
      if (tab.background_file_id) {
        let background = FWFile.findOrCreate({id: tab.background_file_id});
        if (
          !background.get('created_at') &&
          !this.props.filesFetched.includes(tab.background_file_id)
        ) {
          this.props.filesFetched.push(tab.background_file_id);
          let self = this;
          background.fetch().then(function() {
            self.forceUpdate();
          });
        }
        backgroundUrl = background.helper.thumbnailUrl(1280);
      }
      const divStyle = backgroundUrl
        ? {
            padding: 0,
            margin: 0,
            textAlign: 'center',
            position: 'relative',
            minHeight: tabHeight,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundImage: 'url(' + backgroundUrl + ')'
          }
        : {
            padding: 0,
            margin: 0,
            textAlign: 'center',
            position: 'relative',
            minHeight: tabHeight
          };
      return (
        <div
          key={`tab-${i}`}
          style={{
            width: '100%',
            visibility: this.props.selectedTab === i ? 'visible' : 'hidden',
            position: this.props.selectedTab === i ? 'relative' : 'fixed',
            left: this.props.selectedTab === i ? 0 : -99999
          }}
        >
          <div style={divStyle}>
            <div
              className="tab"
              style={{
                left: 0,
                width: '100%',
                minHeight: tabHeight,
                backgroundColor: tab.background,
                borderRadius: 0
              }}
            >
              <InlineEditableElement
                fontFamilyChanged={this.props.fontFamilyChanged.bind(this)}
                className="container tabContainer"
                html={tab.content}
                onChange={this.props.tabChanged.bind(this, i)}
                inlineEditingEnabled={this.props.inlineEditingEnabled}
              />
            </div>
          </div>
        </div>
      );
    });

    return (
      <div className={'tabSection col-md-12'} style={{padding: 0, margin: 0}}>
        <ul
          style={{textAlign: 'center', padding: 0}}
          className={'tabList clearfix ' + tabStyle}
        >
          {tabButtons}
        </ul>
        {tabs}
      </div>
    );
  }
}

export {tabsHoc as hoc};
export default tabsHoc(Tabs);
